import { InfinityIcon, SyncIcon, ZapIcon } from '@primer/octicons-react';

export const getRunTypeIcon = (runType) => {
  if (runType === 'Oneshot') {
    return ZapIcon;
  } else if (runType === 'NetworkService') {
    return InfinityIcon;
  }

  return SyncIcon;
}
